<template>
  <div>
    <header-component></header-component>
    <main class="hogo-houshin-main">
      <section>
        <h1>個人情報保護方針</h1>
        <hr>
        
        <p class="right">2022年11月1日改正<br>
        2007年7月4日制定<br>
        株式会社オムニ<br>
        代表取締役　髙井 令</p>

        <p>株式会社オムニは、個人情報を保護することが重要な責務であると認識し、当社での個人情報保護マネジメントシステム定着への活動を日々推進しています。当社は個人情報の保護に関する法律を遵守し、個人情報を取扱う事業者としてなすべきことについて次の方針を掲げます。本方針は、外部公開するとともに全従業者に周知し、各自の教育、啓発に努め個人情報保護意識の向上を図ります。</p>

        <ol>
          <li>当社は、事業並びに雇用等において取扱う個人情報の特定された利用目的の範囲の中で個人情報の適切な取得・利用を行い、利用目的の達成に必要な範囲を超えた個人情報の取扱い(目的外利用）を行わないこと及びそのための措置を講じます。</li>
          <li>当社は個人情報の取扱いに関する法令、国が定める指針及びその他の規範を遵守します。</li>
          <li>当社は個人情報への不正アクセス、個人情報の漏えい、滅失又は毀損の防止を行い、不適切な事項については是正を行うなどの内部規程を定め、個人情報を保護します。</li>
          <li>当社は個人情報の取扱いに関する苦情及び相談対応への内部規程を定め、苦情及び相談に対応します。</li>
          <li>当社は個人情報保護マネジメントシステムの継続的改善を行います。</li>
        </ol>

        <p class="right">個人情報保護相談受付窓口　管理部長<br>
        〒461-0005 名古屋市東区東桜1丁目13番3号NHK名古屋放送センタービル12階<br>
        TEL：052-971-7653/FAX：052-971-7654<br>
        お問い合わせ <a href="http://www.omnint.co.jp/contact/">www.omnint.co.jp/contact/</a></p>

        <hr>
        <p>【当社における個人情報の取り扱いについて】</p>
        <p>株式会社オムニ（以下「当社」といいます）では、個人情報を厳重に管理するために、以下の内容を実施します。</p>

        <ol>
          <li>当社では、個人情報を以下のような目的で利用させていただきます。また、当社が取得する個人情報のうち、書面により本人から直接取得する場合については、原則として個別に利用目的を明示いたします。
            <ol>
              <li>取引先個人情報<br>取引先との業務、契約締結手続き業務、取引管理業務、信用管理業務及びこれらに準ずる業務の遂行</li>
              <li>派遣スタッフ個人情報<br>スタッフ登録申込の受付・選考・合否連絡、各種派遣業務への受付・諸手続き、本人への連絡、登録後の人事労務管理業務、派遣管理業務、派遣先等への勤務状況の照会等及びこれらに準ずる業務の遂行</li>
              <li>採用応募者情報<br>本人への通知・連絡、面接のための連絡・受付、応募者選考、採用合否判定及びこれらに準ずる業務の遂行</li>
              <li>社員個人情報<br>人事労務管理業務、安全衛生管理業務、福利厚生予約・利用業務及びこれらに準ずる業務の遂行</li>
              <li>サービス利用者個人情報<br>ご利用いただいているサービスの情報提供、契約に伴う事前審査・本人確認、各種サービスの提供、緊急時の当社提携医療機関への連絡、業務運営上に必要な事務の遂行、緊急時の連絡</li>
              <li>各種問い合わせ時個人情報<br>各種相談、問い合わせへの回答及びこれらに準ずる業務の遂行</li>
            </ol>
          </li>
          <li>個人情報は、処理のために当社の基準を満たす委託先に業務委託することがあります。なお、委託先以外の第三者に対しては、原則ご本人様の同意なしでは提供いたしません。</li>
          <li>個人情報に関するご相談・苦情は、個人情報保護方針に記載の連絡先までお申し出ください。</li>
        </ol>
        <p class="right">以上</p>
      </section>
      <section>
        <h1>プライバシーポリシー</h1>
        <hr>
        <section>
          <h2>プライバシーポリシーについて</h2>
          <p>訪問支援マッチングサービスアネラプライバシーポリシー（以下「本ポリシー」といいます）は、株式会社オムニ（以下「当社」といいます）が提供するサービス「訪問支援マッチングサービスアネラ」（以下「本サービス」といいます）における個人情報の取扱を定めたものです。なお、本ポリシーに定めのない事項については「個人情報保護に関する基本方針」をあわせてご確認ください。</p>
        </section>
        <section>
          <h2>個人情報の取得、利用目的</h2>
          <section>
            <h3>取得する情報の一覧</h3>
            <p>当社は、本サービスの提供にあたり、ユーザーから以下の情報を取得する場合があります。</p>
            <ol>
              <li>
                ユーザーからご提供いただく情報
                <ol>
                  <li>
                    全ユーザーからご提供いただく情報
                    <ol>
                      <li>氏名</li>
                      <li>性別</li>
                      <li>生年月日</li>
                      <li>電話番号</li>
                      <li>パスワード</li>
                      <li>メールアドレス</li>
                      <li>住所、最寄り駅</li>
                      <li>プロフィール表示用写真データ</li>
                      <li>本サービスの中で行われたコミュニケーション内容</li>
                      <li>お問い合わせの際にご提供いただいた情報</li>
                      <li>お支払い用クレジットカード情報</li>
                    </ol>
                  </li>
                  <li>
                    サポーター等の療育サービスの提供を受けるために本サービスを利用するユーザー（以下「保護者」といいます）からのみご提供頂く情報
                    <ol>
                      <li>お子さまの氏名、生年月日</li>
                      <li>アレルギー、かかりつけ医等療育に必要なお子さまに関するプロフィール情報</li>
                      <li>希望する療育内容</li>
                      <li>運転免許証・パスポート等の官公署が発行した顔写真付きの身分証明書のコピーまたは画像</li>
                      <li>職業・勤務先名（または学校名）・電話番号</li>
                      <li>緊急連絡先の氏名・続柄・電話番号・職業・勤務先名（または学校名）・勤務先の電話番号</li>
                    </ol>
                  </li>
                  <li>
                    保護者に対し、療育サービスの提供を行なうために本サービスを利用するユーザー（以下「サポーター」といいます）のみご提供頂く情報
                    <ol>
                      <li>療育サービスの利用料の振込先銀行口座</li>
                      <li>往訪可能エリア</li>
                      <li>療育経験、職歴、学歴、資格、言語等の経歴情報</li>
                      <li>療育方針等を記載する自己紹介文</li>
                      <li>運転免許証・パスポート等の官公署が発行した顔写真付きの身分証明書のコピーまたは画像</li>
                    </ol>
                  </li>
                </ol>
              </li>
              <li>
                自動的に取得する情報
                <ol>
                  <li>本サービスの利用状況</li>
                  <li>IPアドレス</li>
                  <li>Cookie情報</li>
                  <li>端末固有の識別情報及びユーザーエージェント</li>
                  <li>本サービス登録後に当社が付与するID及びパスワード</li>
                  <li>Android端末からのみ取得する情報</li>
                  <ol>
                    <li>Registration ID（プッシュ通知用トークン）</li>
                  </ol>
                  <li>
                    iOS端末からのみ取得する情報
                    <ol>
                      <li>Device Token（プッシュ通知用トークン）</li>
                    </ol>
                  </li>
                </ol>
              </li>
            </ol>
          </section>
          <section>
            <h3>利用目的</h3>
            <p>当社は、取得した情報を以下の目的で利用いたします。</p>
            <ol>
              <li>本サービスの提供</li>
              <li>ユーザー同士のコミュニケーション</li>
              <li>当社とユーザー間のコミュニケーション</li>
              <li>本サービス利用状況の調査、分析</li>
              <li>マーケティング調査、アンケートの実施</li>
              <li>本サービスの改善、不具合対応</li>
              <li>当社又は第三者が運営する各種サービス、プロモーション、キャンペーン、イベント等のご案内</li>
              <li>広告表示及びその表示内容の最適化</li>
              <li>利用規約違反行為の是正</li>
              <li>お問い合わせ対応（本人確認を含みます）</li>
              <li>「3．第三者提供」記載の共同利用者への提供</li>
            </ol>
          </section>
        </section>
        <section>
          <h2>個人情報の取得、利用目的</h2>
          <section>
            <h3>第三者との共同利用</h3>
            <p>当社は、以下の共同利用先と記載の利用目的に基づき、個人情報を共同利用することがあります。</p>
            <ol>
              <li>
                本サービスに登録済の保護者
                <ol>
                  <li>利用目的: 療育サービスの依頼の検討、療育サービスの依頼及び療育サービスの利用</li>
                  <li>対象情報: サポーターの氏名、居住エリア、療育経験等のプロフィール情報、顔写真のサムネイル画像、年代</li>
                  <li>提供方法: 電子メール、ウェブブラウザ、携帯端末向けアプリケーションのいずれかによる電磁的提供</li>
                  <li>対象情報の管理に責任を有する者：株式会社オムニ</li>
                </ol>
              </li>
              <li>
                本サービスに登録済のサポーター
                <ol>
                  <li>利用目的: 療育サービスの引受可否判断、療育サービスの引受及び療育サービスの提供</li>
                  <li>対象情報: 保護者及び保護者の子供に関するプロフィール情報、その他予約・お問い合わせの際に個別に入力頂いた情報</li>
                  <li>提供方法: 電子メール、ウェブブラウザ、携帯端末向けアプリケーションのいずれかによる電磁的提供</li>
                  <li>対象情報の管理に責任を有する者：株式会社オムニ</li>
                </ol>
              </li>
            </ol>
          </section>
        </section>
        <section>
          <h2>通知・公表又は同意取得の方法、利用者関与の方法</h2>
          <section>
            <h3>通知・公表</h3>
            <p>本ポリシーは、個人情報を取得する画面、本サービスのウェブページ又はアプリケーションの内部若しくはアプリストア(App Store、Google Playなど)のアプリケーションダウンロードページに設置されたプライバシーポリシーリンク先に掲示・公表しております。当社は本ポリシーを変更することがあり、重要な変更を行なう際は本サービス内において告知いたします。変更後の本ポリシーは、本サービス内又は各掲示箇所に掲示された時点から適用されるものとします。</p>
          </section>
          <section>
            <h3>同意取得の方法</h3>
            <p>本サービスは利用規約及び本ポリシーをご確認いただき、同意の上でご利用ください。ユーザーが本サービスを利用すること（変更後の本ポリシーについては、変更後に本サービスの利用継続）を以て、本ポリシーに同意したものとみなされます。</p>
          </section>
          <section>
            <h3>情報の取得・送信の停止</h3>
            <p>本サービスを所定の手順で退会することで（本サービスのアプリケーションを携帯端末にダウンロードされている方は、退会の上、携帯端末よりアプリケーションを削除(アンインストール)することで）、情報の取得及び送信を停止をすることができます。</p>
          </section>
        </section>
        <section>
          <h2>開示等請求、お問い合わせ</h2>
          <section>
            <h3>開示、訂正、追加、削除、利用停止等の請求</h3>
            <p>当社は、ユーザー本人又はその代理人から当該ユーザーの個人情報の開示、訂正、削除、利用停止等の請求があった場合、法令に基づき可能な範囲で遅滞なく対応を行います。</p>
          </section>
        </section>
      </section>
    </main>
    <footer-component></footer-component>
  </div>
</template>

<script>
import HeaderComponent from "./HeaderComponent";
import FooterComponent from "./FooterComponent";

export default {
  metaInfo: {
    title: "個人情報保護方針 | 訪問支援マッチングサービスアネラ - 訪問支援マッチングサービスアネラは全国でご利用いただける障がい児向け訪問型療育サービスです。お気軽にお問い合わせください。"
  },
  components: {
    HeaderComponent,
    FooterComponent
  }
}
</script>

<style lang="scss" scoped>
main {
  margin-bottom: 40px;
  padding: 10px;
  section {
    font-size: 14px;
    h1 {
      margin: 1em 0;
      line-height: 1em;
      text-align: center;
      font-size: 16px;
    }
    hr {
      border: none;
      border-top: solid 1px #666;
    }
    p {
      margin: 2em 0 0 0;
    }
    .right {
      text-align: right;
    }
    li:nth-of-type(n+2) {
      margin-top: 1em;
    }
    .header {
      font-size: 14px;
    }
  }
  @media (min-width: 576px) {
    section {
      font-size: 16px;
      h1 {
        font-size: 30px;
      }
      .header {
        font-size: 16px;
      }
    }
  }
  @media (min-width: 1220px) {
    padding: 10px calc(50% - 600px);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/HogoHoushin.vue